// extracted by mini-css-extract-plugin
module.exports = {"small":"_61b51642","large":"_3c7b1291"};